import { apnProfilesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("apn-profiles"),
  endpoint: "apn-profiles",
  operations: apnProfilesOps,
  roleView: [ROLE.EMZ_DEVELOPER],
  roleAdmin: [ROLE.EMZ_DEVELOPER],
  singularName: (t) => t("APN profile"),
  name: (t) => t("APN profiles"),
  syncCustomerFilter: true,
});
export default conf;
